import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updateUser } from '@flecto/api/shared'
import { type CoreUserPayload } from '@flecto/types'

import { getUserQueryKey } from './useQueryGetUserLogged'

type MutationPayload = {
  user: CoreUserPayload
}

export function useMutationUpdateUserLogged() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationUpdateUser'],
    onSuccess: () => queryClient.invalidateQueries(getUserQueryKey),
    mutationFn: async ({ user }: MutationPayload) => {
      return await updateUser(user)
    },
  })
}
